import { GridCellParams } from '@mui/x-data-grid-pro';
import { Fragment } from 'react/jsx-runtime';
import { GridCustomColDef } from '../../types';
import {
  advancedEnumOperators,
  advancedNumericOperators,
  advancedOperators
} from '../../Compounds/UpstackDataGrid/helpers';
import { ChildCustomer } from '../../../store/Customer';
import { getCommissionsInfoByType, UserInfo } from '../../../store/GeneralStore';
import { RecordLink } from '../../Atoms/RecordLink';

export const DefaultCustomerGridColumnDefs = (): GridCustomColDef[] => [
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'name',
    headerName: 'Name',
    sortable: true,
    width: 300,
    filterable: true,
    renderCell: (params: GridCellParams) => (
      <RecordLink to={`/customer/${params.row.id}`}>
        <div className="flex items-center text-small">{params.value as string}</div>
      </RecordLink>
    ),
    hideable: false,
    disableReorder: true,
    pinned: 'left',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: getCommissionsInfoByType('customer', 'customerSegment'),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'segment',
    headerName: 'Customer Segment',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: getCommissionsInfoByType('customer', 'partnershipSegmentation'),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'partnershipSegmentation',
    headerName: 'Partnership Segmentation',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'salesAgent',
    headerName: 'Sales Agent',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'commissionsExperienceAnalyst',
    headerName: 'CEA',
    filterable: false,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    type: 'singleSelect',
    valueOptions: getCommissionsInfoByType('user', 'cea').map((us) => (us as UserInfo).email),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'commissionsExperienceAnalystEmail',
    headerName: 'CEA Email',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'customerSuccessManager',
    headerName: 'CSM',
    filterable: false,
    flex: 1,
    description: 'Drag to move column'
  },
  {
    type: 'singleSelect',
    valueOptions: getCommissionsInfoByType('user', 'csm').map((us) => (us as UserInfo).email),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'customerSuccessManagerEmail',
    headerName: 'CSM Email',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedEnumOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'billingAddress',
    headerName: 'Billing Address',
    filterable: false,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'shippingAddress',
    headerName: 'Shipping Address',
    filterable: false,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'assetCount',
    headerName: 'Asset Count',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'rpmAccountCount',
    headerName: 'RPM Account Count',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'sf_id',
    headerName: 'Salesforce ID',
    filterable: false,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'id',
    headerName: 'UPSTACK ID',
    filterable: false,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'parentCustomer',
    headerName: 'Parent Customer',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams) => {
      if (params.row.parentCustomerId) {
        return (
          <RecordLink to={`/customer/${params.row.parentCustomerId}`}>
            <div className="flex items-center text-small">{params.value as string}</div>
          </RecordLink>
        );
      } else {
        return <></>;
      }
    }
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'ultimateParent',
    headerName: 'Ultimate Parent',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams) => {
      if (params.row.ultimateParentId) {
        return (
          <RecordLink to={`/customer/${params.row.ultimateParentId}`}>
            <div className="flex items-center text-small">{params.value as string}</div>
          </RecordLink>
        );
      } else {
        return <></>;
      }
    }
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'childCustomers',
    headerName: 'Child Customers List',
    filterable: false,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    renderCell: (params: GridCellParams) => (
      <>
        {params.row.childCustomers?.map((c: ChildCustomer, index: number) => (
          <Fragment key={c.id}>
            {index > 0 && <span>, </span>}
            <RecordLink
              className="text-indigo inline-block"
              to={`/customer/${c.id}`}>
              <div className="flex items-center text-small">{c.name as string}</div>
            </RecordLink>
          </Fragment>
        ))}
      </>
    )
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'childCustomersCount',
    headerName: 'Child Customers Count',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedNumericOperators(),
    hideByDefault: true
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'paCount',
    headerName: 'PA Count',
    sortable: true,
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'assetBncCount',
    headerName: 'BnC Asset Count',
    sortable: true,
    filterable: true,
    width: 200,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    field: 'assetCommissioningCount',
    headerName: 'Commissioning Asset Count',
    sortable: true,
    filterable: true,
    width: 200,
    description: 'Drag to move column',
    hideByDefault: true,
    filterOperators: advancedNumericOperators()
  }
];
